var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ConsoleTypes, TAG } from '@heimdallr-sdk/types';
import { formateUrlPath, hasConsole } from '@heimdallr-sdk/utils';
import { Subscribe } from './lib/subscribe';
var Core = (function () {
    function Core(options) {
        var _this = this;
        if (!this.isRightEnv()) {
            this.log('Client does not match the environment');
            return;
        }
        this.isReady = false;
        this.taskQueue = [];
        this.options = options;
        this.bindOptions();
        this.initAPP().then(function (id) {
            if (id && _this.appID !== id) {
                _this.appID = id;
            }
            _this.isReady = true;
            _this.executeTaskQueue();
        });
    }
    Core.prototype.bindOptions = function () {
        var _a = this.options, dsn = _a.dsn, app = _a.app, _b = _a.debug, debug = _b === void 0 ? false : _b, _c = _a.enabled, enabled = _c === void 0 ? true : _c;
        if (!app || !dsn) {
            this.log('Mising app or dsn in options');
            return;
        }
        var host = dsn.host, init = dsn.init, _d = dsn.upload, upload = _d === void 0 ? '' : _d;
        var initUrl = formateUrlPath(host, init);
        var uploadUrl = formateUrlPath(host, upload);
        this.context = {
            app: app,
            uploadUrl: uploadUrl,
            initUrl: initUrl,
            debug: debug,
            enabled: enabled
        };
    };
    Core.prototype.use = function (plugins) {
        var _this = this;
        var _a = this.context, uploadUrl = _a.uploadUrl, enabled = _a.enabled;
        var sub = new Subscribe();
        var _loop_1 = function (plugin) {
            plugin.monitor.call(this_1, sub.notify.bind(sub, plugin.name));
            var callback = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pluginDatas = plugin.transform.apply(_this, args);
                var datas = _this.transform(pluginDatas);
                if (!datas) {
                    return;
                }
                if (!enabled) {
                    return;
                }
                if (!_this.isReady) {
                    _this.taskQueue.push(datas);
                    return;
                }
                _this.nextTick(_this.report, _this, uploadUrl, __assign({ app_id: _this.appID }, datas));
            };
            sub.watch(plugin.name, callback);
        };
        var this_1 = this;
        for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
            var plugin = plugins_1[_i];
            _loop_1(plugin);
        }
    };
    Core.prototype.executeTaskQueue = function () {
        var uploadUrl = this.context.uploadUrl;
        while (this.taskQueue.length) {
            var task = this.taskQueue.shift();
            this.nextTick(this.report, this, uploadUrl, __assign({ app_id: this.appID }, task));
        }
    };
    Core.prototype.getOptions = function () {
        return __assign({}, this.options);
    };
    Core.prototype.log = function (message, type) {
        if (type === void 0) { type = ConsoleTypes.WARN; }
        var debug = this.context.debug;
        if (!hasConsole() || !debug) {
            return;
        }
        var func = console[type];
        if (typeof func !== 'function') {
            this.log('Type does not exist');
            return;
        }
        func(TAG, message);
    };
    return Core;
}());
export { Core };
